/*
 * Copyright (c) Hilo 2020.
 * Author: fharold
 *
 * hilo-oauth-manager
 * UserAddDTO.ts
 */

import {Type} from "../../../tools/view/form/FormInput";
import Translation from "../../../services/translation/Translation";
import {TextField} from "../../../tools/model/form/TextField";
import {AbstractForm} from "../../../tools/model/form/AbstractForm";
import {UserEditPasswordDTO} from "../../dto/user/UserEditPasswordDTO";

export default class UserEditPasswordForm extends AbstractForm<UserEditPasswordDTO> {
    constructor() {
        super();

        this.fields.set(UserEditPasswordDTO.OLD_PASSWORD, new TextField(
            UserEditPasswordDTO.OLD_PASSWORD,
            (t: Translation) => t.oldPassword,
            value => value.toString().length !== 0,
            Type.PASSWORD,
            true,
            "",
            ""
        ));

        this.fields.set(UserEditPasswordDTO.NEW_PASSWORD, new TextField(
            UserEditPasswordDTO.NEW_PASSWORD,
            (t: Translation) => t.newPassword,
            value => value.toString().length !== 0,
            Type.PASSWORD,
            true,
            "",
            ""
        ));
    }

    /**
     * load
     * @param dto
     */
    public load(dto: UserEditPasswordDTO): void {
        const oldPasswordField = this.fields.get(UserEditPasswordDTO.OLD_PASSWORD);
        if (oldPasswordField) {
            oldPasswordField.value = dto.oldPassword;
        }

        const newPasswordField = this.fields.get(UserEditPasswordDTO.NEW_PASSWORD);
        if (newPasswordField) {
            newPasswordField.value = dto.newPassword;
        }
    }
}
